import {Injectable} from "@angular/core";
import {Router} from "@angular/router";
import {AuthService} from "./auth.service";
import {HttpClient} from "@angular/common/http";
import {EventTrackingService} from './event-tracking.service';
import {WrenchApiService} from './wrench-api.service';

@Injectable()
export class MembershipService extends WrenchApiService {
    constructor(
        protected http: HttpClient,
        protected authService: AuthService,
        protected router: Router,
        protected eventTrackingService: EventTrackingService) {

        super(http, authService, router, eventTrackingService);

    } // constructor()

    /**
     * get member details
     * @param params
     */
    getMember(params: any) {
        return this.http.post(this.authService.getBackendUrl("/user/getmember"), JSON.stringify(params), this.authService.getAuthHeaders())
            .catch(error => { return this.handleError(error); });
    }

    /**
     * Enroll in membership
     * @param params
     */
    enroll(params: any) {
        return this.http.post(this.authService.getBackendUrl("/user/enrollmember"), JSON.stringify(params), this.authService.getAuthHeaders())
            .catch(error => { return this.handleError(error); });
    }

    /**
     * cancel the membership for the user
     */
    cancelMembership() {
        let params = {userId: this.authService.getUserIdFromToken()};
        return this.http.post(this.authService.getBackendUrl("/transaction/cancelmembership"), JSON.stringify(params), this.authService.getAuthHeaders())
            .catch(error => { return this.handleError(error); });
    }

    /**
     * update member
     * @param params
     */
    updateMember(params: any) {
        return this.http.post(this.authService.getBackendUrl("/transaction/updatemember"), JSON.stringify(params), this.authService.getAuthHeaders())
            .catch(error => { return this.handleError(error); });
    }

    /**
     * get membership quote
     * @param params
     */
    getMembershipQuote(params: any) {
        return this.http.post(this.authService.getBackendUrl("/transaction/getmembershipquote"), JSON.stringify(params), this.authService.getAuthHeaders())
            .catch(error => { return this.handleError(error); });
    }

    /**
     * get membership
     * @param params
     */
    getMembership(params: any) {
        return this.http.post(this.authService.getBackendUrl("/user/getmembership"), JSON.stringify(params), this.authService.getBasicAuthHeaders())
            .catch(error => { return this.handleError(error); });
    }

    /**
     * get membership pricing plans
     * @param params
     */
    getPricingPlans(params: any) {
        return this.http.post(this.authService.getBackendUrl("/user/getpricingplans"), JSON.stringify(params), this.authService.getBasicAuthHeaders())
            .catch(error => { return this.handleError(error); });
    }

    /**
     * get broker
     * @param params
     */
    getBroker(params: any) {
        return this.http.post(this.authService.getBackendUrl("/user/getbroker"), JSON.stringify(params), this.authService.getBasicAuthHeaders())
            .catch(error => { return this.handleError(error); });
    }

} // MembershipService
